import { CollapseComponent } from '@opten/collapse';
import { factory } from '@opten/compiler/factory';
import {
	Chart,
	Filler,
	LineElement,
	PointElement,
	RadarController,
	RadialLinearScale,
} from 'chart.js';
import { AlertComponent } from './components/shared/alert';

import { ChartComponent } from './components/pgf/chart';
import { TabComponent } from './components/pgf/tab';
import { DatepickerComponent } from './components/shared/datepicker';
import { FilterComponent } from './components/shared/filter';
import { FormCheckboxesComponent } from './components/shared/form-checkboxes';
import { FormSelectUpdateComponent } from './components/shared/form-select-updater';
import { FormTemplatesComponent } from './components/shared/form-templates';
import { FormTotalComponent } from './components/shared/form-total';
import { GlobalVarsComponent } from './components/shared/globalvars';
import { GridComponent } from './components/shared/grid';
import { InputComponent } from './components/shared/input';
import { ModalComponent } from './components/shared/modal';
import { PageTopComponent } from './components/shared/page-top';
import { PageTransitionComponent } from './components/shared/page-transition';
import { PasswordRevealComponent } from './components/shared/password-reveal';
import { ProgressComponent } from './components/shared/progress';
import { ReCaptchaComponent } from './components/shared/recaptcha';

Chart.register(
	RadarController,
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler
);

const initialize = factory([
	CollapseComponent,
	ModalComponent,
	FilterComponent,
	ProgressComponent,
	InputComponent,
	FormTotalComponent,
	FormTemplatesComponent,
	FormCheckboxesComponent,
	FormSelectUpdateComponent,
	PasswordRevealComponent,
	DatepickerComponent,
	PageTransitionComponent,
	GridComponent,
	ReCaptchaComponent,
	PageTopComponent,
	ChartComponent,
	TabComponent,
	AlertComponent,
]);

initialize(document.body);

PageTransitionComponent.onPageChange.subscribe((container) => {
	initialize(container);
});

const vars = new GlobalVarsComponent();
